import {Injectable} from "@angular/core";

function _window() : any {
  return window;
}

@Injectable()
export class WindowRefService {

  get nativeWindow() : any {
    return _window();
  }

  get location(): any {
    return this.nativeWindow.location;
  }

  get origin(): any {
    return this.location.origin;
  }


}



// WEBPACK FOOTER //
// ./src/app/core/services/window-ref.service.ts